module.exports = __webpack_public_path__ + "img/btn_menu_shjdh.bad6e3e9.png";